import { useEffect } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useThemeStore } from './store/theme'
import { useAuthStore } from './store/auth'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import Games from './pages/Games'
import GameEdit from './pages/GameEdit'
import { Images } from './pages/Images'
import { Settings } from './pages/Settings'
import Layout from './components/layout/Layout'

function App() {
  const { isDark, setDark } = useThemeStore()
  const { checkAuth } = useAuthStore()

  useEffect(() => {
    // 初始化主题
    const savedTheme = localStorage.getItem('theme')
    if (savedTheme) {
      setDark(savedTheme === 'dark')
    } else {
      setDark(window.matchMedia('(prefers-color-scheme: dark)').matches)
    }
  }, [])

  // 受保护路由
  const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
    return checkAuth() ? <>{children}</> : <Navigate to="/login" />
  }

  return (
    <BrowserRouter>
      <div className={isDark ? 'dark' : ''}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <Layout>
                  <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/games" element={<Games />} />
                    <Route path="/games/new" element={<GameEdit />} />
                    <Route path="/games/:id" element={<GameEdit />} />
                    <Route path="/images" element={<Images />} />
                    <Route path="/settings" element={<Settings />} />
                    <Route path="*" element={<Navigate to="/" />} />
                  </Routes>
                </Layout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </div>
    </BrowserRouter>
  )
}

export default App
